import { GetApiAuditLogQueryParams } from '@sit/openapi';
import { createContext, use } from 'react';

export type Audit = Pick<GetApiAuditLogQueryParams, 'objectType' | 'key'>;

export interface ActiveAudit extends Audit {
  visible: boolean;
}

export type AuditContextType = {
  active: ActiveAudit | null;
  loadAudit: (audit: Audit) => void;
};

export const AuditContext = createContext<AuditContextType>({
  active: null,
  loadAudit: () => undefined,
});

export function useAudit() {
  const { active, loadAudit } = use(AuditContext);

  function openAudit(audit: Audit) {
    loadAudit(audit);
  }

  function openTimeClockAudit(clockId: string) {
    openAudit({ objectType: 'time-clock', key: clockId });
  }

  return { active, openAudit, openTimeClockAudit };
}
